import React from "react";
import AppView from "../../components/Layout/AppView";

const AppointmentsPage = () => {
  return <AppView>Appointments Page</AppView>;
};

export default AppointmentsPage;
